import { render, staticRenderFns } from "./miniAppAgreement.vue?vue&type=template&id=5fbca9d5&scoped=true"
import script from "./miniAppAgreement.vue?vue&type=script&lang=js"
export * from "./miniAppAgreement.vue?vue&type=script&lang=js"
import style0 from "./miniAppAgreement.vue?vue&type=style&index=0&id=5fbca9d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbca9d5",
  null
  
)

export default component.exports